<div data-testid="fandc-generator-fandc-generator-container" class="fandc-generator-container">
  <dx-scroll-view data-testid="fandc-generator-scroll-view" #scrollView>
        <div>
          <dx-form data-testid="form"
            id="form"
            class="cards-wide"
            [formData]="fandCRequestData"
            [showValidationSummary]="true"
            validationGroup="formGroup"
            (onFieldDataChanged)="onFormDataChanged($event)"
          >
            <dxi-item itemType="group"
                      cssClass="dx-widget"
                      [colCount]="16"
                      labelMode="static">
              <!-- Show SelectBox when no metadata, otherwise show plain text -->
              <ng-container *ngIf="!taskGenerationMetadata">
                <dxi-item labelMode="static"
                          dataField="loanNumber"
                          editorType="dxSelectBox"
                          [colSpan]="3"
                          [editorOptions]="{
                  items: (filteredLoanData$ | async) || [],
                  valueExpr: '',
                  displayExpr: 'name',
                  required: 'true',
                  searchMode: 'contains',
                  searchEnabled: true,
                  itemTemplate: loanItemTemplate
                  }">
                  <dxo-label text="Loan Number"> </dxo-label>
                  <dxi-validation-rule type="required"
                                       message="Loan Number is required">
                  </dxi-validation-rule>
                </dxi-item>
        <dxi-item
          editorType="dxCheckBox"
          [colSpan]="1"
          [label]="{ visible: false}"
          cssClass="loan-checkbox-center-align small-font"
          [editorOptions]="{ text: activeLoanCheckboxText , onValueChanged: onShowInactiveLoansChanged, value: false}"
        >
        </dxi-item>
              </ng-container>

              <!-- Show plain text when metadata is present -->
              <ng-container *ngIf="taskGenerationMetadata">
                <dxi-item editorType="dxTextBox"
                          [colSpan]="4"
                          cssClass="loan-number-readonly"
                          [editorOptions]="{
                      value:  (selectedLoanNumber$ | async)?.facilityDetail?.name || 'N/A',
                      disabled: true
                    }">
                  <dxo-label text="Loan Number"></dxo-label>
                </dxi-item>
              </ng-container>

              <dxi-item labelMode="static"
                        dataField="selectedTemplateType"
                        editorType="dxSelectBox"
                        [colSpan]="4"
                        [editorOptions]="templateTypeEditorOptions">
                <dxo-label text="Type"> </dxo-label>
                <dxi-validation-rule type="required" message="Type is required">
                </dxi-validation-rule>
              </dxi-item>

              <dxi-item labelMode="static"
                        dataField="category"
                        editorType="dxSelectBox"
                        [colSpan]="4"
                        cssClass="dx-widget"
                        [editorOptions]="templateEditorOptions">
                <dxo-label text="Category"> </dxo-label>
                <dxi-validation-rule type="required"
                                     message="Category is required">
                </dxi-validation-rule>
              </dxi-item>

              <dxi-item labelMode="static"
                        dataField="frequency"
                        editorType="dxSelectBox"
                        [colSpan]="4"
                        cssClass="dx-widget"
                        [editorOptions]="frequencyEditorOptions">
                <dxo-label text="Frequency"> </dxo-label>
                <dxi-validation-rule type="required"
                                     message="Frequency needs to be selected">
                </dxi-validation-rule>
              </dxi-item>

              <!-- Show dropdown for non-One-Time frequencies -->
              <dxi-item labelMode="static"
                        dataField="frequencyOffsetOption"
                        editorType="dxSelectBox"
                        [colSpan]="4"
                        cssClass="dx-widget"
                        [visible]="selectedFrequency !== 'One-Time'"
                        [editorOptions]="frequencyOffsetEditorOptions">
                <dxo-label text="Due"> </dxo-label>
                <dxi-validation-rule type="required"
                                     message="Due needs to be selected">
                </dxi-validation-rule>
              </dxi-item>

              <!-- Show date selector for One-Time frequency -->
              <dxi-item labelMode="static"
                        dataField="oneTimeDueDate"
                        editorType="dxDateBox"
                        [colSpan]="4"
                        cssClass="dx-widget"
                        [visible]="selectedFrequency === 'One-Time'"
                        [editorOptions]="oneTimeDueDateOptions">
                <dxo-label text="Due Date"> </dxo-label>
                <dxi-validation-rule type="required"
                                     message="Due date needs to be selected">
                </dxi-validation-rule>
              </dxi-item>

              <dxi-item labelMode="static"
                        dataField="format"
                        editorType="dxSelectBox"
                        [colSpan]="4"
                        cssClass="dx-widget"
                        [editorOptions]="formatEditorOptions">
                <dxo-label text="Format"> </dxo-label>
                <dxi-validation-rule type="required"
                                     message="Format needs to be selected">
                </dxi-validation-rule>
              </dxi-item>

              <dxi-item labelMode="static"
                        dataField="reportEntity"
                        editorType="dxSelectBox"
                        [colSpan]="4"
                        cssClass="dx-widget"
                        [editorOptions]="reportEntityOptions">
                <dxo-label text="Report Entity"> </dxo-label>
                <dxi-validation-rule type="required"
                                     message="Report entity needs to be selected">
                </dxi-validation-rule>
              </dxi-item>

              <dxi-item labelMode="static"
                        dataField="entityName"
                        editorType="dxSelectBox"
                        [colSpan]="4"
                        cssClass="dx-widget"
                        [editorOptions]="customEntityNameOptions">
                <dxo-label text="Entity Name"> </dxo-label>
                <dxi-validation-rule type="required"
                                     message="Entity name needs to be selected">
                </dxi-validation-rule>
              </dxi-item>

              <dxi-item labelMode="static"
                        dataField="referenceDate"
                        editorType="dxDateBox"
                        [colSpan]="4"
                        [editorOptions]="referenceDateOptions">
                <dxo-label text="Reference date"> </dxo-label>
                <dxi-validation-rule type="required"
                                     message="Reference date is required">
                </dxi-validation-rule>
              </dxi-item>

              <dxi-item labelMode="static"
                        dataField="maturityDate"
                        editorType="dxDateBox"
                        [colSpan]="4"

                        [editorOptions]="maturityDateOptions">
                <dxo-label text="Maturity date"> </dxo-label>
                <dxi-validation-rule type="required"
                                     message="Maturity date is required">
                </dxi-validation-rule>
              </dxi-item>

              <dxi-item labelMode="static"
                        [colSpan]="7"
                        dataField="taskTypes"
                        editorType="dxTagBox"
                        cssClass="dx-widget"
                        [editorOptions]="defaultTasksEditorOptions">
                <dxo-label text="Tasks to be created"> </dxo-label>
              </dxi-item>
              <dxi-item cssClass="user-button detail-submit mt-2"
                        [colSpan]="1"
                        horizontalAlignment="left"
                        editorType="dxButton"
                        [editorOptions]="{
                  text: '+',
                  useSubmitBehavior: false,
                  validationGroup: 'formGroup',
                  cssClass: 'user-button mb-1 mt-1',
                  horizontalAlignment: 'left',
                  onClick: addPrototypeTasks.bind(this),
                  disabled: !isTaskTypesSelected
                }"></dxi-item>

            </dxi-item>
          </dx-form>


    <div *ngIf="selectedPrototypeTasks && selectedPrototypeTasks.length > 0">
          <dx-data-grid data-testid="fandc-generator-data-grid"
            #prototypeTasksGrid
            [dataSource]="selectedPrototypeTasks"
            [showBorders]="true"
            [editing]="{ mode: 'cell', allowUpdating: true }"
            (onRowUpdated)="onPrototypeRowUpdated($event)"
            (onExporting)="onExporting($event)"
            [export]="{ enabled: true, allowExportSelectedData: false }"
          >
          <!-- Add these three elements to enable filtering -->
          <dxo-header-filter [visible]="true"></dxo-header-filter>

            <dxo-export [enabled]="true"></dxo-export>

            <!-- For each column, you can also specify filter-specific options -->
            <dxi-column dataField="type" [allowFiltering]="true"></dxi-column>
            <dxi-column dataField="category" [allowFiltering]="true"></dxi-column>
            <dxi-column dataField="frequency" [allowFiltering]="true"></dxi-column>
            <dxi-column dataField="due" [allowFiltering]="true"></dxi-column>
            <dxi-column dataField="taskName" caption="Document Name" [allowFiltering]="true"></dxi-column>
            <dxi-column dataField="format" [allowFiltering]="true"></dxi-column>
            <dxi-column
              dataField="notes"
              caption="Notes"
              [allowEditing]="true"
            ></dxi-column>
            <dxi-column
              dataField="referenceDate"
              caption="Reference Date"
              [allowEditing]="false"
              dataType="date"
              format="MM/dd/yyyy"
            ></dxi-column>
            <dxi-column
              dataField="firstDueDate"
              caption="First Due"
              [allowEditing]="true"
              dataType="date"
              format="MM/dd/yyyy"
            ></dxi-column>

            <dxi-column dataField="reportEntityLabel" caption="Report Entity"></dxi-column>
            <dxi-column dataField="entityName" caption="Entity Name"></dxi-column>
            <dxi-column
              dataField="reference"
              caption="Reference"
              [allowEditing]="true"
            ></dxi-column>
            <dxi-column
              type="buttons"
              caption="Actions"
              [buttons]="[
                {
                  hint: 'Delete',
                  icon: 'trash',
                  onClick: deletePrototypeTask
                }
              ]">
            </dxi-column>
          </dx-data-grid>

          <div data-testid="fandc-generator-action-buttons" class="action-buttons">
            <dx-form data-testid="fandc-generator-form">
              <dxi-item
                [colSpan]="1"
                cssClass="user-button detail-submit mb-1 mt-1"
                horizontalAlignment="right"
                editorType="dxButton"
                [editorOptions]="{
                  text: 'Preview tasks',
                  useSubmitBehavior: false,
                  validationGroup: 'formGroup',
                  cssClass: 'user-button mb-1 mt-1',
                  horizontalAlignment: 'right',
                  onClick: generateTasks.bind(this)
                }"
              ></dxi-item>
            </dx-form>
          </div>
    </div>

    <div
      *ngIf="generatedTasks && generatedTasks.length > 0"
      #generatedTasksElement
    >

          <div style="font-weight: bold">Previewed tasks</div>
          <dx-data-grid data-testid="fandc-generator-data-grid-1"
            [dataSource]="generatedTasks"
            [showBorders]="true"
            (onRowUpdated)="onGeneratedTaskRowUpdated($event)"
          >
            <dxi-column dataField="task.name" caption="Task Name"></dxi-column>
            <dxi-column
              dataField="task.dueDate"
              caption="Due Date"
              dataType="date"
              format="MM/dd/yyyy"
            ></dxi-column>
            <dxi-column
              dataField="task.team"
              caption="Team"
            ></dxi-column>
            <dxi-column
              dataField="task.assignedUserName"
              caption="Assigned User"
            ></dxi-column>
          </dx-data-grid>

          <!-- <div data-testid="fandc-generator-action-buttons" class="action-buttons">
            <dx-form data-testid="fandc-generator-form-1">
              <dxi-item
                [colSpan]="1"
                cssClass="user-button detail-submit mb-1 mt-1"
                horizontalAlignment="right"
                editorType="dxButton"
                [editorOptions]="{
                  text: 'Save tasks',
                  useSubmitBehavior: true,
                  validationGroup: 'formGroup',
                  cssClass: 'user-button mb-1 mt-1',
                  horizontalAlignment: 'right',
                  onClick: saveTasks.bind(this)
                }"
              ></dxi-item>
            </dx-form>
          </div> -->
    </div>
              <div data-testid="fandc-generator-action-buttons" class="action-buttons">
            <dx-form data-testid="fandc-generator-form-2">
              <dxi-item
                cssClass="user-button detail-submit mb-1 mt-1"
                horizontalAlignment="right"
                editorType="dxButton"
                [editorOptions]="{
                  text: 'Save',
                  useSubmitBehavior: false,
                  validationGroup: 'formGroup',
                  cssClass: 'user-button mb-1 mt-1',
                  horizontalAlignment: 'right',
                  onClick: saveGenerationTask.bind(this),
                  disabled: !this.isLoanNumberPopulated
                }"
              ></dxi-item>
            </dx-form>
          </div>
    </div>
    <dx-load-panel data-testid="fandc-generator-load-panel"
      [container]="'.fandc-generator-container'"
      [position]="{
        of: '.fandc-generator-container',
        at: 'center',
        my: 'center'
      }"
      [visible]="isLoadingLoanData || isGeneratingTasks || isSavingTasks || isLoadingMetadata || isSavingGenerationTask"
      [message]="isSavingGenerationTask ? 'Saving...' : 'Loading...'"
      [showPane]="true"
      [showIndicator]="true"
    ></dx-load-panel>
    </dx-scroll-view>
</div>
